import * as yup from 'yup';
import {i18n2} from 'features/i18n/i18n';

export const CollaboAssistantSchema = (management = false) => {
  const realCollaboSchema = () =>
    yup.object({
      employee_Nr: yup.number().max(8).label(i18n2._('Numero de empleado')),
      cwid: yup.string().max(39).label(i18n2._('CWID')),
      name: yup
        .string()
        .required(i18n2._('Este campo es obligatorio'))
        .max(100)
        .label(i18n2._('Nombre')),
      iD_Sector: yup.number().label(i18n2._('Sector')),
      iD_Profile_Web: yup.number().label(i18n2._('Perfil')),
      iD_Shift: yup.number().nullable(true).label(i18n2._('Turno')),
      sector_Name: yup.string().label(i18n2._('Sector')),
      profile_Name: yup.string().label(i18n2._('Profile')),
      shift_Name: yup.string().label(i18n2._('Shift')),
    });

  const assistanceSchema = () =>
    yup.object({
      assists: yup.boolean().label(i18n2._('Inscripto')),
    });

  return management === true
    ? assistanceSchema().concat(realCollaboSchema())
    : realCollaboSchema();
};
